import LoginPage from './RecoverPassword';

export default LoginPage;
